import { CustomSnackbar } from "./CustomSnackbar";
import NoLogo from "../assets/images/featured-job/no-logo.png";
import UserAvatar from "../assets/images/avatar.png";

import { Link } from "react-router-dom";
import moment from "moment";

// http://localhost/jobseekers-backend/api/web
// export const apiUrl = "http://localhost/jobseekers-backend/api/web";
// export const dataUrl = "http://localhost/jobseekers-backend/data";
export const apiUrl = "https://sdsjobseekers.runasp.net/api";
// export const apiUrl = "https://jobseekerspage.com/backend/api/web";
export const dataUrl = "https://sdsjobseekers.runasp.net/api";

export const userId_local_storage_key = "jobseekerspage_userId";
export const authKey_local_storage_key = "webvi_authToken";
export const cartData_local_storage_key = "jobseekerspage_cart_data";
export const userInfo_local_storage_key = "jobseekerspage_userInfo";
export const recently_viewed_item_key = "jobseekerspage_recently_viewed_jobs";
export const redirect_url_key = "jobseekerspage_redirect_url";
export const last_logged_in_username_key =
  "jobseekerspage_last_logged_in_username";
console.log(userInfo_local_storage_key, "CHECK");

export const capitalize = (str) =>
  `${str.charAt(0).toUpperCase() + str.substr(1).toLowerCase()}`;

export const sortFn = (el1, el2, sortKey = "display_order") =>
  el1[sortKey] > el2[sortKey] ? 1 : -1;

export const preferredDeliveryCategoryId = [52];

export const getIds = (array, column) => {
  const ids = [];
  array.forEach((element) => {
    ids.push(element?.additional_fields?.[column]);
  });
  return ids;
};

export function isValidURL(string) {
  var res = string.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)/g,
  );
  return res !== null;
}

export const isValidMobile = (val) => {
  var mob_regex = /^(?:(?:\+|0{0,2})91(\s*[-]\s*)?|[0]?)?[6789]\d{9}$/;

  if (mob_regex.test(val)) {
    return true;
  } else {
    return false;
  }
};

export function humanReadableSize(bytes) {
  let size = parseInt(bytes);
  for (let unit of ["b", "Kb", "Mb", "Gb"]) {
    if (size < 1024) return `${size.toFixed(1)} ${unit}`;
    size /= 1024.0;
  }
}

export function scrollWindow(top = 100) {
  return window.scrollTo({
    top,
    behavior: "smooth",
  });
}

export const imageUrl = (
  imageName,
  prefix = "contents",
  sizePrefix = "120x120-",
) => `${dataUrl}/${prefix}/${sizePrefix}${imageName}`;

export const getMenusByCategory = (menus, categoryName) =>
  menus.filter((menu) => menu.category === categoryName);

export const productImageUrl = (
  url,
  prefix = "products",
  id = "1",
  sizePrefix = "120x120-",
) => `${dataUrl}/${prefix}/${id}/${sizePrefix}${url}`;

export const testimonialimageUrl = (url, prefix = "products") =>
  `${dataUrl}/${prefix}/${url}`;

export const convertToSlug = (text) => {
  return (
    text &&
    text
      ?.toLowerCase()
      ?.replace(/[^\w ]+/g, "")
      ?.replace(/ +/g, "-")
  );
};

// get time stamp in seconds
export function getTimestampInSeconds() {
  return Math.floor(Date.now() / 1000);
}

export const getDateTimestamp = (date) => {
  return moment(date).format("DD MMM YYYY HH:mm:ss");
};

export const getContentByName = (contents, name, defaultValue) => {
  // 1. Agar contents null ya undefined hai toh default value return karo
  if (!contents) return defaultValue;

  // 2. Data extract karein (Agar contents ek object hai jisme 'result' ya 'data' array hai)
  const actualArray = Array.isArray(contents)
    ? contents
    : contents.result || contents.data || [];

  // 3. Agar ab bhi array nahi mila, toh crash hone se bachao
  if (!Array.isArray(actualArray)) return defaultValue;

  // 4. Ab safely .find() chalayein
  const foundContent = actualArray.find((content) => content.name === name);

  return foundContent ? foundContent : defaultValue;
};

export const getAssetsByName = (assets = [], name, defaultValue) => {
  return assets?.find((asset) => asset.name === name) || defaultValue;
};

export const getCategoryByName = (categories, name) => {
  return categories?.find(
    (category) => category.name.toLowerCase() === name.toLowerCase(),
  );
};

export const getCategoriesByParentName = (categories, parentName) => {
  let parentId = getCategoryByName(categories, parentName)?.id;
  return categories.filter(
    (category) => parseInt(category.parent_id) === parseInt(parentId),
  );
};

export const getJobLocationById = (locationId, locationsList) => {
  if (!locationId || !locationsList?.length) return "";

  const found = locationsList.find(
    (loc) => String(loc.id) === String(locationId),
  );

  return found ? `${found.name}, ${found.state}` : "";
};
export const getParsedJson = (json, defaultValue = "{}") => {
  let parsedJson = defaultValue;

  try {
    if (isJsonString(json)) {
      parsedJson = JSON.parse(json ?? defaultValue);
    }

    if (isJsonString(parsedJson)) {
      parsedJson = JSON.parse(parsedJson ?? defaultValue);
    }
  } catch (error) {
    parsedJson = JSON.parse(defaultValue);
  }

  return parsedJson;
};

export function isPlanExpired(expiryDate) {
  // Parse the expiry date string into a Date object
  const expiration = new Date(expiryDate);
  // Get the current date and time
  const now = new Date();
  // Check if the current date is after the expiry date
  return now > expiration;
}

export const filterByCategoryName = (contents, categoryName, defaultValue) =>
  contents.filter((content) => content.category === categoryName) ||
  defaultValue;

export const getCategoryLink = (category) =>
  `/category/${category.id}/${category.url_slug}/1`;

export const getContentByCategoryName = (
  contents,
  categoryName,
  defaultValue,
) =>
  contents.filter((content) => content.category === categoryName) ||
  defaultValue;

export const getSettingByKey = (settings, keyName, defaultValue) => {
  if (!settings) return defaultValue;

  // Case A: If settings is a direct plain object map (e.g., { total_work_experiences: { value: '...' } })
  if (
    !Array.isArray(settings) &&
    !Array.isArray(settings?.data) &&
    typeof settings === "object"
  ) {
    if (settings[keyName]) {
      return settings[keyName];
    }
  }

  // Case B: If settings is an array, or an object containing a data array
  const settingsArray = Array.isArray(settings)
    ? settings
    : settings?.data || [];

  const foundSetting = settingsArray.find(
    (setting) => setting?.key === keyName,
  );

  // Return the found object setting, otherwise fallback gracefully
  return foundSetting ? foundSetting : defaultValue;
};

export function searchJobs(jobs, departments = ["All"], locations = ["All"]) {
  // if (departments.includes('All') || locations.includes('All')) {
  //   return jobs;
  // }

  // if (departments.length === 0 && locations.length === 0) {
  //   return jobs;
  // }

  // if (departments.length > 0 && locations.length === 0) {
  //   return jobs.filter((job) => departments.includes(job.department));
  // }

  // if (departments.length === 0 && locations.length > 0) {
  //   return jobs.filter((job) => locations.includes(job.location));
  // }

  // if All departments and All locations are selected

  return jobs?.filter(
    (job) =>
      (departments.includes("All") || departments.includes(job.department)) &&
      (locations.includes("All") || locations.includes(job.location)),
  );
}

export const openInNewWindow = (url) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

export const openUrlNewWindow = (menu) => {
  const url = menu?.url;
  if (menu?.open_in_new_window === "yes") {
    openInNewWindow(url);
  }
};

// getting splitted array from string by setting key
export function getSplittedArrayBySettingsKey(keyValue, settings) {
  const array = getSettingByKey(settings, keyValue)?.value;
  return keyValue ? toArray(array, "\n") : [];
}

export const getTestimonialByName = (
  clienttestimonials,
  company,
  defaultValue,
) =>
  clienttestimonials?.find(
    (clienttestimonial) => clienttestimonial.company === company,
  ) || defaultValue;

export const getTestimonialByCompanyName = (clienttestimonials, companyName) =>
  clienttestimonials?.filter(
    (clienttestimonial) => clienttestimonial.company === companyName,
  );

export function isUserEmployer(customer) {
  return customer?.customer_type === 1;
}

export function isEmailVerified(data) {
  if (!data) return false;

  // Extract candidate values from all potential paths in Redux / API
  const status =
    data?.customer?.is_email_verified ??
    data?.customer?.isEmailVerfied ??
    data?.data?.is_email_verified ??
    data?.data?.isEmailVerfied ??
    data?.is_email_verified ??
    data?.isEmailVerfied;

  // If status is 1, it's explicitly verified
  if (status === 1 || status === "1" || status === true) {
    return true;
  }

  // If status is strictly null or undefined, check if the email didn't change
  // (prevents breaking the UI when Update API sends null)
  if (status === null || status === undefined) {
    return true; // Or return previous known state
  }

  return false;
}

export function isMobileVerified(data) {
  return data?.customer?.is_mobile_verified === 1;
}

export function detectLoginMethod(input) {
  if (!input) return null;

  // Check if it's a valid email
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(input)) {
    return "email";
  }

  // Check if it's a valid mobile number using existing validateMobileNumber function
  const mobileValidation = validateMobileNumber(input);
  if (mobileValidation === "") {
    return "mobile_number";
  }

  return null;
}

export const getCategoryByParentId = (categories, parentId) =>
  categories?.filter(
    (category) => parseInt(category.parent_id) === parseInt(parentId),
  );

// it is used to make the given string into array by splitting using the given seperator.
export const toArray = (value, seperator = ",") => {
  let arr = [];

  if (value) {
    arr = value
      ?.split(seperator)
      .filter(Boolean)
      .map((v) => v.trim())
      .filter((v) => v !== "");
  }
  return arr;
};

export function getRandomArrayItems(array, count) {
  const shuffled = array?.sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

// Divide array into chunks
export function sliceIntoChunks(arr, chunkSize) {
  const res = [];
  for (let i = 0; i < arr?.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    res.push(chunk);
  }
  return res;
}

// Array of object accending order => Name A to Z
export function toAccendingOrder(array) {
  return array?.sort((a, b) => {
    return a?.name > b?.name ? 1 : -1;
  });
}

// check img exists or not in the given url
export const checkImgExists = (url) => {
  var img = new Image();
  img.src = url;
};

//  check img exists or not in the given url
export function imageExists(image_url) {
  var http = new XMLHttpRequest();

  http.open("HEAD", image_url, false);
  http.send();

  return http.status !== 404;
}

// it is used to get the image url from the given html.
// export const getImageUrl = (html) => {
//     let img = html.match(/<img.*?src="(.*?)"/);
//     // let regex = /src="(.*?)"/i;
//     // let match = regex.exec(html);
//     return match[1];
// }

export const getUrlParams = (paramName, paramValue) => {
  let url = document.location;
  var urlObj = new window.URL(url);
  urlObj.searchParams.set(paramName, paramValue);

  return urlObj.searchParams.toString();
};

export const removeUrlParam = (paramName) => {
  let url = document.location;
  var urlObj = new window.URL(url);
  urlObj.searchParams.delete(paramName);
  return urlObj.searchParams.toString();
};

export const getAppliedFilters = (paramName) => {
  let url = document.location;
  var urlObj = new window.URL(url);
  return urlObj.searchParams.get(paramName);
};

export const getFilterPath = (params, prefix = "jobs") => {
  return `/${prefix}?${params}`;
};

export const getImageUrl = (html) => {
  let img = html.match(/<img.*?src="(.*?)"/);
  return img[1];
};

export function getFirstCharacter(fullName) {
  let fname = fullName?.replace(/\s+/g, " ").trim();
  fname = fname?.split(" ");
  let firstNames = [];
  if (fname[0]) {
    if (fname[0][0]) {
      firstNames.push(fname[0][0]);
    }
  }
  if (fname[1]) {
    if (fname[1][0]) {
      firstNames.push(fname[1][0]);
    }
  }
  return firstNames.join("").toUpperCase();
}

export const getFirstChar = (word) => {
  return word?.charAt(0).toUpperCase() ?? "";
};

export const renderMonth = (value) => {
  switch (value) {
    case "01":
      return "Jan";
    case "02":
      return "Feb";
    case "03":
      return "Mar";
    case "04":
      return "Apr";
    case "05":
      return "May";
    case "06":
      return "Jun";
    case "07":
      return "Jul";
    case "08":
      return "Aug";
    case "09":
      return "Sep";
    case "10":
      return "Oct";
    case "11":
      return "Nov";
    case "12":
      return "Dec";
    default:
      return "";
  }
};

export function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const showErrorMessage = (error) => {
  if (error?.includes("Your request was made with invalid credentials")) {
    CustomSnackbar.error(
      "To proceed with your request, kindly log in to your account.",
    );
  } else {
    CustomSnackbar.error(error);
  }
};

export const apiErrorHandler = (err) => {
  let error = "Something went wrong.";

  if (err?.response?.data && err?.response?.data[0]?.message) {
    error = err?.response?.data[0]?.message;
  } else if (err?.response?.data?.message) {
    error = err?.response?.data?.message;
  } else {
    error = err?.message;
  }

  if (error) {
    showErrorMessage(error);
  }
};

export const getTotalVacancies = (job) => {
  const numOfVacancies = job?.totalNumberOfVacancies;

  if (numOfVacancies > 1) {
    return `${numOfVacancies} Vacancies`;
  } else if (numOfVacancies > 0) {
    return `${numOfVacancies} Vacancy`;
  } else {
    return "No Vacancy";
  }
};

export const getJobResponsibility = (job) => {
  if (!job?.jobResponsibilities) {
    return "No Responsibilities Required";
  }

  return job.jobResponsibilities;
};

export const getJobExperiences = (job) => {
  // Extract the raw value cleanly from the object
  const expValue = job?.minimumExperienceRequired;

  // 1. Check if the value is missing, null, or undefined
  if (!expValue) {
    return "Exp Not required";
  }

  // 2. Convert to string and clean it up (removes trailing/leading spaces)
  const expString = String(expValue).trim();

  // 3. Handle cases where the backend sends explicitly "0", "0 Years", or "not required"
  // RegEx checks for exact 0 values like "0", "0 year", "0 years", "0 yrs" (case-insensitive)
  const isZeroOnly = /^0\s*(years?|yrs?)?$/i.test(expString);

  if (isZeroOnly || expString.toLowerCase().includes("not required")) {
    return "Exp Not required";
  }

  // 4. Return the actual experience string directly (e.g., "0-1 Years", "0.5 Years", "1-2 Years")
  return expString;
};

export const getSalaryAmount = (job, suffix = "month", showIcon = true) => {
  const salary = typeof job === "object" ? job?.minimumSalaryPerMonth : job;

  if (!salary) return null;

  return (
    <>
      {showIcon && <i className="uil uil-wallet text-primary"></i>}{" "}
      {`₹${salary} / ${suffix}`}
    </>
  );
};

export const getCompanyLogo = (logo) => {
  if (logo) {
    // Construct the URL to match the profile_image folder structure
    const baseUrl = "https://sdsjobseekers.runasp.net/uploads/company_logo";

    // Generates a clean ISO format timestamp: YYYY-MM-DDTHH:mm:ssZ
    const timestamp = new Date().toISOString().split(".")[0] + "Z";

    return `${baseUrl}/${logo}?t=${timestamp}`;
  } else {
    return NoLogo;
  }
};

export const getUserPic = (pic) => {
  // Check if pic exists and isn't just a placeholder string from the DB
  if (pic && pic !== "string" && pic !== "") {
    return `${pic}`;
  }
  // If no picture, return a generic placeholder URL (since you don't want UserAvatar)
  return UserAvatar;
};

export const getKeywords = (list) => {
  let listArr = toArray(list, ",");

  if (listArr?.length) {
    return listArr.map((h, index) => (
      <li className="list-inline-item" key={"keywords-" + index}>
        <Link to="#" className="primary-link text-muted text-capitalize">
          {h}
        </Link>
        {index === listArr.length - 1 ? "" : ","}
      </li>
    ));
  }

  return <span>Not available</span>;
};

export const getJobsByType = (jobs, type) => {
  if (!Array.isArray(jobs)) return []; // ✅ prevent crash

  return jobs.filter(
    (job) => job?.jobType?.toLowerCase?.() === type?.toLowerCase?.(),
  );
};

export const getUnreadNotifications = (data) => {
  return data?.unreadCount || 0;
};

export function sumObjectValues(obj) {
  let sum = 0;
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      sum += obj[key];
    }
  }
  return sum;
}

export function validateUsername(username) {
  // Check if the username is a string
  if (typeof username !== "string") {
    return "Username must be a string.";
  }

  // Check if the username is between 6 and 30 characters long
  if (username.length < 6 || username.length > 30) {
    return "Username must be between 6 and 30 characters long.";
  }

  // Check if the username contains only alphanumeric characters and underscores
  var validCharacters = /^[a-zA-Z0-9_]+$/;
  if (!validCharacters.test(username)) {
    return "Username must contain only alphanumeric characters and underscores.";
  }

  // If all checks pass, the username is valid
  return "";
}

export function validateMobileNumber(mobileNumber) {
  // Check if mobile number is provided
  if (!mobileNumber || !mobileNumber.trim()) {
    return "Mobile number is required.";
  }

  // Check if mobile number is a valid number
  const mob_regex = /^(?:(?:\+|0{0,2})91(\s*[-]\s*)?|[0]?)?[6789]\d{9}$/;

  if (!mob_regex.test(mobileNumber)) {
    return "Please enter a valid mobile number.";
  }

  return "";
}

export function validateEmail(email) {
  // Check if email is provided
  if (!email || !email.trim()) {
    return "Email address is required.";
  }

  // Check email format using regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email.trim())) {
    return "Please enter a valid email address.";
  }

  // Check email length (reasonable limits)
  if (email.length > 254) {
    return "Email address is too long.";
  }

  // Check for common invalid patterns
  if (email.includes("..") || email.startsWith(".") || email.endsWith(".")) {
    return "Please enter a valid email address.";
  }

  return "";
}

export const filterDuplicateArray = (array, key = "value") => {
  if (!array?.length) {
    return [];
  }

  const seen = new Set();
  const filteredArray = array?.filter((item) => {
    // Determine the value to check based on whether a key is provided
    const identifier = key && typeof item === "object" ? item[key] : item;

    if (!seen.has(identifier)) {
      seen.add(identifier);
      return true;
    }
    return false;
  });
  return filteredArray;
};

function capitalizeString(str) {
  // First, convert the entire string to lowercase.

  str = str.toLowerCase();

  // Then, replace the first character of each word with its uppercase counterpart.
  return str.replace(/\b\w/g, function (char) {
    return char.toUpperCase();
  });
}

export const getDropdownOptions = (
  array,
  objStructure = { label: "state", value: "id" },
) => {
  let data = [];

  if (array && array.length > 0) {
    array.forEach((e) => {
      if (e[objStructure?.label]) {
        let label = capitalizeString(e[objStructure?.label]?.trim()) || "";

        data.push({
          label,
          value: e[objStructure?.value],
        });
      }
    });
  }

  return data;
};

export const getWorkExpText = (total_work_experience) => {
  return `${total_work_experience} ${
    total_work_experience !== "Fresher" ? "" : ""
  }`;
};

export function loggedInWithin30Days(lastLoginDateString) {
  const lastLoginDate = new Date(lastLoginDateString);
  const currentDate = new Date();

  const difference = currentDate - lastLoginDate;
  const differenceInDays = difference / (1000 * 3600 * 24);

  return differenceInDays <= 30;
}

export function getFileExtension(fileName) {
  if (fileName) {
    const a = fileName?.split(".");
    if (a.length === 1 || (a[0] === "" && a.length === 2)) {
      return "";
    }
    return a.pop();
  }
  return "";
}

export const isInsufficientCreditError = (message) =>
  message === "No credits available." ||
  message === "Your credits are expired" ||
  message === "You do not have enough credits to see this candidate profile.";

export const buyCreditsAlert = (
  message = "No credits available.",
  redirectPath,
) => {
  const conf = window.confirm(`${message}, Do you want to buy some credits?`);
  if (conf) {
    if (redirectPath) {
      localStorage.setItem("redirect_path_after_buy_credits", redirectPath);
    }

    window.open("/pricing", "_self");
  }
};

export function getCreditText(value) {
  return value === 1 ? "credit" : "credits";
}

//Limit the characters to specific length (to get truncate text)
export const limitCharacters = (value, maxLimit) =>
  value?.length > maxLimit ? value?.substring(0, maxLimit - 3) + "..." : value;

export const downloadPdfFromBinaryData = (data, fileName, fileExt = "pdf") => {
  try {
    // Assuming the PDF data is received in binary format ('arraybuffer')
    const pdfBlob = new Blob([data], { type: "application/pdf" });

    // Create a link element
    const link = document.createElement("a");

    // Create a URL for the blob
    const pdfURL = window.URL.createObjectURL(pdfBlob);

    // Set link properties
    link.href = pdfURL;
    link.download = `${fileName}.${fileExt}`;

    // Append the link to the body (usually not needed to be visible)
    document.body.appendChild(link);

    // Programmatically trigger the download
    link.click();

    // Clean up by revoking the object URL and removing the link
    window.URL.revokeObjectURL(pdfURL);
    document.body.removeChild(link);
  } catch (error) {
    showErrorMessage("Unable to download document!");
    console.log("error::", error);
  }
};

export const decodeHtmlEntities = (str) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
};

export function fileSaver(url, name, loading, token) {
  loading(true);

  fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Sorry, something went wrong while downloading.");
      }
      return response.arrayBuffer();
    })
    .then((buffer) => {
      const objectUrl = window.URL.createObjectURL(new Blob([buffer]));
      const link = document.createElement("a");
      link.href = objectUrl;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();

      // Release the object URL for better performance
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(link);
    })
    .catch((err) => {
      apiErrorHandler(err);
      console.error("Error during file download:", err);
    })
    .finally(() => {
      loading(false);
    });
}

// to capitalized text example: hello world => Hello World
export function titleCase(str) {
  return str?.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
}

export function getTimeAgo(dateString) {
  const now = new Date();
  const past = new Date(dateString);
  const diffInSeconds = Math.floor((now - past) / 1000);

  const seconds = diffInSeconds;
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);
  const years = Math.floor(days / 365);

  if (seconds < 60) return "just now";
  if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
  if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
  if (days < 7) return `${days} day${days !== 1 ? "s" : ""} ago`;
  if (weeks < 5) return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
  if (months < 12) return `${months} month${months !== 1 ? "s" : ""} ago`;
  return `${years} year${years !== 1 ? "s" : ""} ago`;
}

export function isUserActive(dateString) {
  if (!dateString) return false;
  const now = new Date();
  const past = new Date(dateString);
  const diffInDays = Math.floor((now - past) / (1000 * 60 * 60 * 24));

  return diffInDays <= 7;
}

export function formatDate(dateString) {
  const date = new Date(dateString);

  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = date.getFullYear();

  // Format: DD-MM-YYYY
  return `${day}-${month}-${year}`;
}
